import React from "react";
import { string } from "prop-types";
import Icon from "../Icon";

const ModalClose = ({ title = "Close", ...props }) => {
	return (
		<button
			aria-label={title}
			className="modal__header-button-close"
			data-dismiss="modal"
			type="button"
			{...props}
		>
			<Icon name="times" size="l" />
		</button>
	);
};

ModalClose.propTypes = {
	title: string,
};

export default ModalClose;
